import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";
import { IntegrationStatus } from "types/enums";

export const useIntegrationStatusSelectOptions = () => {
    const { t } = usePaldockTranslation("forms.integration-general.enums.status");

    const options = [
        { label: t("creating"), value: IntegrationStatus.Creating },
        { label: t("ready"), value: IntegrationStatus.Ready },
        { label: t("stopped"), value: IntegrationStatus.Stopped },
        { label: t("testing"), value: IntegrationStatus.Testing },
    ];

    return { options, loading: false, error: null };
};
